<template>
  <div class="privacy">
    <h1 class="privacy-title">Shopify App: Additional Charges and Billing Transparency</h1>
    <div>
      <h2>Overview:</h2>
      <p class="privacy-text ml-0">
        The Pacsort app is free to install and use for all merchants via the Shopify App Store. We do not charge any
        fees for accessing the app or generating shipping labels.
      </p>
      <p class="privacy-text ml-0">
        However, depending on how the merchant chooses to access shipping services, delivery costs may apply, and may
        billed either by the carrier directly or through Pacsort under certain billing agreements.
      </p>
      <h2>What’s Free:</h2>
      <ul>
        <li>- Installation and use of the Pacsort app</li>
        <li>- Generating shipping labels</li>
        <li>- Access to shipping methods and carrier selection</li>
        <li>- Automated label uploads into Shopify orders</li>
      </ul>

      <p class="privacy-text ml-0">
        There are <b>no subscription fees, no in-app purchases, and no usage-based charges</b> applied by Pacsort for
        the app itself.
      </p>

      <h2>When Charges May Apply:</h2>
      <p class="privacy-text ml-0">
        While Pacsort itself does not charge for using the app, shipping services (i.e. physical parcel delivery) may
        involve charges, depending on how the service is provisioned:
      </p>
      <ul>
        <li>
          - Direct Carrier Billing: The merchant has a direct relationship with the carrier (e.g., PostNord, DHL, or
          others) and is billed by the carrier under their own contract and pricing terms.
        </li>
        <li>
          - Pacsort-Managed Carrier Access: Merchants can choose to use Pacsort’s negotiated carrier agreements. In such
          cases: Pacsort pays the carrier directly, The merchant receives a monthly invoice from Pacsort for accumulated
          shipping costs based on the amount of shipments made through the app.
        </li>
      </ul>

      <h2>Important Notes:</h2>
      <ul>
        <li>- Pacsort never charges for label generation</li>
        <li>- All charges are related strictly to actual delivery services</li>
        <li>- The app has no built-in billing functionality and does not process payments through Shopify</li>
      </ul>

      <p class="privacy-text ml-0">
        For more details, please refer to our Terms of Use
        <a href="https://pacsortonline.com/info/terms-of-use/">Terms of Use</a>
      </p>
      <p class="privacy-text ml-0">
        If you have any questions, feel free to contact our support team at support@pacsortonline.com.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Terms',
})
</script>
